import { styled } from "@mui/material/styles";

const LoaderMain = styled("div")(({ theme }) => ({
  position: "fixed",
  top: "0",
  left: "0",
  backgroundColor: "rgba(0,0,0,0.4)",
  height: "100vh",
  width: "100vw",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
}));

export { LoaderMain };
